const usuario = {
    namespaced: true,
    state: {
        usuario: {
            id: null,
            nome: null,
            email: null,
            senha: null,
        },
        token: null,
    },
    mutations: {
        UPDATE_USUARIO (state, payload) {
            state.usuario = payload;
        },
        UPDATE_TOKEN (state, payload) {
            state.token = payload;
        },
        LOGIN (state, payload) {
            state = payload;
        },
        LOGOUT (state, payload) {
            state.token = payload;
        },
    },
    actions: {
        updateUsuario ({ commit, state }, payload) {
            const usuario = Object.assign(state.usuario, payload);
            commit('UPDATE_USUARIO', usuario);
        },
        updateToken ({ commit }, payload) {
            commit('UPDATE_TOKEN', payload);
        },
        login ({ commit, state }, payload) {
            const usuario = Object.assign(state, payload);
            commit('LOGIN', usuario);
        },
        logout ({ commit }) {
            commit('LOGOUT', null);
        },
    },
    getters: {
        getUsuario: state => state.usuario,
        getToken: state => state.token,
        isLogging (state) {
          return state.token != null;
        },
        isIdeiasUser (state) {
          return state.usuario.role === 'IDEIAS';
        },
        isAdminUser (state) {
          return state.usuario.role === 'IDEIAS' || state.usuario.role === 'ADMIN';
        },
    },
}

export default usuario
